import { Fab } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import adminRoutesConstant from '../../../../constants/adminRoutesConstant';
import { mailTemplateHeadCells } from '../../../../constants/headCells/masterDataHeadCells';
import { permissionNames } from '../../../../constants/permissions';
import { getMessageTemplateByOfferIndentifier, updateMessageTemplate } from '../../../../services/plansService';
import { getTableCrudByPermission } from '../../../../utils/other';
import ScreenWrapper from '../../../commons/ScreenWrapper';
import Table from '../../../commons/Table/dataTable/Table';

const MailTemplateListPage = ({
    match
}) => {
    const admin = useSelector(state => state.auth.admin)
    const { offer_identifier } = match && match.params ? match.params : {};
    const [allTemplates, setAllTemplates] = React.useState([])
    const history = useHistory()

    const goToEditPage = (eachData) => {
        history.push(adminRoutesConstant.adminUrls.MailTemplateEditPage.url(`${String(eachData.id)}/${offer_identifier}`));
    }

    const goToViewPage = (eachData) => {
        history.push(adminRoutesConstant.adminUrls.MailTemplateViewPage.url(`${String(eachData.id)}/${offer_identifier}`));
    }

    const handleDeleteTemplate = row => {
        updateMessageTemplate(row.id, {
            ...row,
            is_deleted: 1,
        }).then(response => {
            fetchDataByOfferIdentifier();
        })
    }

    const handleAction = (rowData, actionKey) => {

        switch (actionKey) {
            case permissionNames.CAN_READ:
                goToViewPage(rowData);
                return;

            case permissionNames.CAN_UPDATE:
                goToEditPage(rowData);
                return;

            case permissionNames.CAN_DELETE:
                handleDeleteTemplate(rowData)
                return;
            default:
                return;
        };

    }

    const fetchDataByOfferIdentifier = () => {
        getMessageTemplateByOfferIndentifier(offer_identifier).then((response) => {
            if (response) {
                setAllTemplates(response)
            }
        });
    }

    React.useEffect(() => {
        if (offer_identifier) {
            fetchDataByOfferIdentifier()
        }
    }, [offer_identifier])

    return (
        <ScreenWrapper
            pageTitle="All Mail Templates"
            ActionComponent={() => (true) ? (
                <Link to={adminRoutesConstant.adminUrls.MailTemplateCreatePage.url(offer_identifier)} style={{ textDecoration: 'none' }}>
                    <Fab size='small' variant="extended" color="primary" aria-label="add">
                        <Add /> Add New Template
                    </Fab>
                </Link >
            ) : null}
        >
            <Table
                tableName='Showing all mail templates'
                headCells={mailTemplateHeadCells}
                tableData={allTemplates}
                onClickAction={handleAction}
                crud={getTableCrudByPermission(admin.permission && admin.permission.Plans)}
            />
        </ScreenWrapper>
    )
}

export default MailTemplateListPage